<style scoped lang="scss">
.draft { color: red }
.panel-block {
  padding: 8px 0;
}
.panel-heading:first-child, .panel-tabs:first-child, .panel-block:first-child {
    border-top: none;
}
.panel-heading:last-child, .panel-tabs:last-child, .panel-block:last-child {
    border-top: 1px solid #dbdbdb;
}
.item {
  border-bottom: .02em solid #999;
  font-weight: normal !important;
  text-align: left;
  padding: 5px 20px;
  width: 100%;

  .story-date {
    color: #000;
    font-size: 12px;
  }

  &:hover {
    text-decoration: none;
  }
  &.is-active {
    background: black;
    color: #fff !important;
    .story-date {
      color: #fff;
    }
  }
}
.decade {
  cursor: pointer;
  user-select: none;
  width: 100%;
}
</style>
<template>
  <div
    class="frow column-start width-100 mt-20 direction-column-reverse"
  >
    <div
      v-for="(decade, key, index) in sortedItems"
      :key="index"
      class="panel-block frow width-100"
    >
      <strong
        class="decade"
        @click="$set(sortedItems[key], 'open',!decade.open)"
      >
        {{ key }}
        <span
          v-if="checkForDrafts(key)"
          class="draft"
        >[Draft]</span>
        <i
          class="icon"
          :class="decade.open ? 'ion-md-arrow-dropup' :'ion-md-arrow-dropdown'"
        />
      </strong>
      <ul
        v-if="decade.open"
        class="width-100"
      >
        <a
          v-for="item in decade.items"
          :key="item.id"
          :class="{'is-active': activeItem.id == item.id}"
          class="item frow row-start"
          @click.prevent="$emit('setActiveItem', item)"
        >
          {{ item.title }}&nbsp;
          <span class="story-date">
            [{{ $moment(item.date).format("MM/DD/YYYY") }}]
            <span
              v-if="item.draft"
              class="draft"
            >[Draft]</span>
          </span>
        </a>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DecadeAccordian',
  props: {
    activeItem: {
      type: Object,
      default: () => {},
    },
    items: {
      type: Array,
      default: () => [], 
    },
  },
  data() {
    return {
      sortedItems: {},
    };
  },  
  watch: {
    items: function() {
      this.sortItems();
    },
  },
  created() {
    this.sortItems();
  },
  methods: {
    getDecade(date) {
      return this.$moment(date).format('YYYY').replace(/.$/,'0');
    },
    sortItems() {
      let sortedItems = {};
      if (this.items) {
        this.items.forEach((item) => {
          let decade = this.getDecade(item.date);
          if (!sortedItems[decade]) {
            sortedItems[decade] = {
              items: [],
              open: false,
            };
          }
          sortedItems[decade].items.push(item); 
        });
      } else {
        console.log('NO ITEMS');
      }
      this.sortedItems = sortedItems;
    },
    checkForDrafts(decade) {
      if (this.sortedItems[decade].items.find((i) => i.draft)) {
        return true;
      }
      return false;
    },
  },
};
</script>
